import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, DurationField, RadioField, SelectField } from '@unite-us/ui';
import formatOptions from '../formatOptions';
import enums from '../../../constants/enums';
import { Form, Field } from 'react-final-form';
import cleanMilitaryFields from '../cleanMilitaryFields';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import callOrLog from '../../../constants/callOrLog';
import { FACESHEET } from '../../../constants/eventConstants';
function MilitaryForm(props) {
  var contact = props.contact;
  var onAffiliationChange = function onAffiliationChange() {
    setTimeout(function () {
      return window.dispatchEvent(new Event('resize'));
    }, 10);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var cleanedData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cleanedData = cleanMilitaryFields(data);
            _context.next = 3;
            return getAdapter('coreApi').updateRecord("person", contact.id, {
              military: cleanedData
            });
          case 3:
            callOrLog(function () {
              return trackEvent(FACESHEET.militaryStatusUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var militaryEnums = enums.contact_data.military;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact.military,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        values = _valuesInstanceProperty(_ref2);
      return /*#__PURE__*/React.createElement("form", {
        ref: props.setFormRef,
        onSubmit: handleSubmit,
        className: "military-form content-with-actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container content-container--medium"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "affiliation"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "affiliation",
          label: "Affiliation",
          options: formatOptions(militaryEnums.affiliation),
          inline: false,
          onChange: onAffiliationChange
        }, params));
      }), /*#__PURE__*/React.createElement("div", {
        className: values.affiliation === 'military_member_or_veteran' ? '' : 'hidden'
      }, /*#__PURE__*/React.createElement(Field, {
        name: "current_status"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "current_status",
          label: "Current Status",
          options: formatOptions(militaryEnums.current_status),
          inline: false
        }, params));
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Currently Transitioning?"), /*#__PURE__*/React.createElement(Field, {
        name: "currently_transitioning"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "transitioning",
          options: formatOptions(militaryEnums.transitioning)
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Has at least one day of active duty outside of basic training?"), /*#__PURE__*/React.createElement(Field, {
        name: "at_least_one_day_active_duty"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "active-duty",
          options: formatOptions(militaryEnums.active_duty)
        }, params));
      })), /*#__PURE__*/React.createElement(Field, {
        name: "branch"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "branch",
          label: "Branch Of Service",
          options: formatOptions(militaryEnums.branch),
          inline: false
        }, params));
      }), /*#__PURE__*/React.createElement(Field, {
        name: "service_era"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "era",
          label: "Service Era",
          options: formatOptions(militaryEnums.service_era),
          inline: false,
          shouldSort: false
        }, params));
      }), /*#__PURE__*/React.createElement(Field, {
        name: "entry_date"
      }, function (startDate) {
        return /*#__PURE__*/React.createElement(Field, {
          name: "exit_date"
        }, function (endDate) {
          return /*#__PURE__*/React.createElement(DurationField, {
            id: "service-dates",
            label: "Service Dates",
            startField: startDate,
            endField: endDate,
            inline: false
          });
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Has client ever been deployed?"), /*#__PURE__*/React.createElement(Field, {
        name: "deployed"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "deployed",
          options: formatOptions(militaryEnums.deployed)
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: values.deployed === 'yes' ? '' : 'hidden'
      }, /*#__PURE__*/React.createElement(Field, {
        name: "deployment_starts_at"
      }, function (startDate) {
        return /*#__PURE__*/React.createElement(Field, {
          name: "deployment_ends_at"
        }, function (endDate) {
          return /*#__PURE__*/React.createElement(DurationField, {
            id: "deployment-dates",
            label: "Deployment Dates",
            startField: startDate,
            endField: endDate,
            inline: false
          });
        });
      })), /*#__PURE__*/React.createElement(Field, {
        name: "discharge_type"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "discharge",
          label: "Military Discharge",
          options: formatOptions(militaryEnums.discharge_type),
          inline: false
        }, params));
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Discharged or retired from military service for a disability incurred in the line of duty?"), /*#__PURE__*/React.createElement(Field, {
        name: "discharged_due_to_disability"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "discharge-disability",
          options: formatOptions(militaryEnums.discharge_disability)
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Has VA-rated Service-Connected Disability?"), /*#__PURE__*/React.createElement(Field, {
        name: "service_connected_disability"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "connected-disability",
          options: formatOptions(militaryEnums.connected_disability)
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: values.service_connected_disability === 'yes' ? '' : 'hidden'
      }, /*#__PURE__*/React.createElement(Field, {
        name: "service_connected_disability_rating"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "disablility-rating",
          label: "Service-Connected Disability Rating",
          options: formatOptions(militaryEnums.disability_rating),
          inline: false,
          shouldSort: false
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-label"
      }, "Proof of veteran status?"), /*#__PURE__*/React.createElement(Field, {
        name: "proof_of_veteran_status"
      }, function (params) {
        return /*#__PURE__*/React.createElement(RadioField, _extends({
          id: "proof",
          options: formatOptions(militaryEnums.proof_of_veteran_status)
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: values.proof_of_veteran_status === 'yes' ? '' : 'hidden'
      }, /*#__PURE__*/React.createElement(Field, {
        name: "proof_type"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "proof-type",
          label: "Proof Type",
          options: formatOptions(militaryEnums.proof_type),
          inline: false
        }, params));
      })))), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-military-cancel-btn",
        label: "Cancel",
        onClick: props.closeModal
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-military-save-btn",
        label: "Save",
        primary: true,
        style: {
          marginLeft: '10px'
        },
        type: "submit"
      }))));
    }
  });
}
export default MilitaryForm;
//# sourceMappingURL=index.js.map